// extracted by mini-css-extract-plugin
export var chevron = "_ju-4";
export var chevronExpanded = "_ju-5";
export var row = "_ju-0";
export var rowBody = "_ju-6";
export var rowDescription = "_ju-7";
export var rowHeader = "_ju-1";
export var rowTitle = "_ju-2";
export var rowTitleComplete = "_ju-3";